import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Customer } from "../../../../shared/types/customers";
import { Profile } from "../../../../shared/models/profile";
import { getApp } from "../app";

@Component({
    selector: "app-user-profile-list",
    templateUrl: "./user-profile-list.component.html",
    styleUrls: ["./user-profile-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserProfileListComponent implements OnInit {
  profiles: Profile[] = [];
  columns: string[] = [];
  usersNames: string[] = [];
  selectedFilters: { columnName: string; value: string }[] = [];

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  async ngOnInit() {
    this.app.type = "personProfile";
    await this.app.profile.getProfiles();
    await this.app.users.getUsersWithRoles();
    this.getSortOption();
  }

  getSortOption() {
    // if (this.app.customers.expectCurrent === Customer.OMP) {
    this.app.table.sortField = "user.name";
    this.app.table.sortDirection = 1;
    // }
  }

  getData(profile: any, column: string) {
    if (profile.sections != null) {
      const field = column.split(".")[1];

      if (column.includes("organizationProfile")) {
        return profile.sections.org[field];
      }

      if (column.includes("personProfile")) {
        return profile.sections.pers[field];
      }
      if (column === "user.email") {
        return profile.sections.pers.Email;
      }
    }

    if (column === "user.name") {
      return profile.name;
    }
    return profile[column];
  }

  navigateProfile(id: string) {
    if (this.app.customers.expectCurrent === Customer.OC) {
      this.app.routing.navigateProfile(id);
    } else {
      this.app.profile.initProfile(id);
    }
  }
}
